import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Icon from "./Icon";
import { canonicalUrl } from "../../Service/seoUrl";

// items: [{ label, to }] — the last item is the current page.
// structuredData=false skips the BreadcrumbList markup (e.g. while the page's
// real names are still loading, so placeholders never reach Google).
function Breadcrumb({ items, structuredData = true }) {
  // Google requires `item` (a URL) on every ListItem, so only crumbs that are
  // real pages go into the markup. The last crumb falls back to the current URL.
  const current = typeof window !== "undefined" ? window.location.pathname : null;
  const linked = items
    .map((item, index) => ({
      name: item.label,
      path: item.to || (index === items.length - 1 ? current : null),
    }))
    .filter((item) => item.name && item.path);

  const markup =
    structuredData && linked.length > 1
      ? {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: linked.map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.name,
            item: canonicalUrl(item.path),
          })),
        }
      : null;

  return (
    <nav className="v-crumbs" aria-label="Breadcrumb">
      {markup ? (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(markup)}</script>
        </Helmet>
      ) : null}
      <ol>
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`}>
              {last || !item.to ? (
                <span aria-current={last ? "page" : undefined}>{item.label}</span>
              ) : (
                <Link to={item.to}>{item.label}</Link>
              )}
              {!last ? <Icon name="chevronRight" size={14} className="v-crumbs__sep" /> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
